import React from 'react'

const Cursor = ({ image = '', name = '', position = {} }) => {
  return (
    <div
      style={{ left: position.left, top: position.top }}
      className={`gp-cursor ${position.down ? 'down' : ''} sketch`}
    >
      <div className='person'>
        {image ? (
          <img className='cursor-image' src={image} />
        ) : (
          <span className='cursor-no-image'>
            {name.split(' ').reduce((acc, v) => acc + v.charAt(0), '')}
          </span>
        )}
        <span className='cursor-name'>{name}</span>
      </div>
      <div className='pointer' />
    </div>
  )
}

export default Cursor
